<template>
  <!-- 模块的同步标题 -->
  <div class="module-title" :style="{background: bgColor ? bgColor:'#fff', borderBottom : borderB == '' ? '' : borderB,  height: heightPx ? heightPx+'px' : '58px'}">
    <div class="title-divider title-divider-color" v-if="showBar"></div>
    <div class="title-name" :style="titleSize!=''?'font-size:'+titleSize:''">{{titleInfo}}</div>
    <div v-if="rightInfo || iconEl" class="title-right" :style="{right: rightPx}">{{rightInfo}}<i :class="iconEl" @click="clickEvent"></i></div>
  </div>
</template>
<script>
export default {
  props: {
    iconEl: {
      //右侧el的icon的class
      type: String,
    },
    rightInfo: {
      //右侧文字
      type: String,
    },
    titleInfo: {
      //标题文字
      type: String,
    },
    bgColor: {
      //背景颜色
      type: String,
    },
    rightPx: {
      //右侧标识的定位位置
      type: String,
      default: '51px',
    },
    borderB: {
      //下划线
      type: String,
    },
    heightPx: {
      //高度
      type: String,
    },
    showBar: {
      type: Boolean,
      default: true,
    },
    titleSize: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {
    console.log('borderB', this.borderB)
  },
  methods: {
    clickEvent() {
      this.$emit('clickEvent')
    },
  },
}
</script>
<style lang="less">
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.module-title {
  .displayFlex;
  position: relative;
  width: 100%;
  // background: linear-gradient(180deg, #ffffff 0%, #e3e3e3 100%);
  .title-divider {
    left: 41px;
  }

  .title-name {
    position: absolute;
    left: 53px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2b2f3f;
  }

  .title-right {
    cursor: pointer;
    position: absolute;
    // right: 51px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    // color: #c1c3cf;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-module-head.vue